import React, { FC } from 'react';

import { Box, HStack, Link } from '@chakra-ui/react';
import { map } from 'lodash';
import { customTheme } from 'theme';

export interface BreadcrumbListOptions {
  label: string;
  onClick?();
}

interface Props {
  list: BreadcrumbListOptions[];
}
export const Breadcrumbs: FC<Props> = props => {
  const { list } = props;

  return (
    <HStack color={customTheme.colors.blue['300']} spacing={1}>
      <Box color="black">{'>>'}</Box>
      <HStack>
        {map(list, (o, index) => (
          <HStack key={index + '-' + o.label}>
            {index === list?.length - 1 ? (
              <Box>{o.label}</Box>
            ) : (
              <Link onClick={o.onClick}>{o.label}</Link>
            )}
            {index !== list?.length - 1 && <Box color="black">/</Box>}
          </HStack>
        ))}
      </HStack>
    </HStack>
  );
};
